import { useTour } from '@reactour/tour';
import { Button, Flex, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MdOutlineClose } from 'react-icons/md';

import { trackOnboardingTourCompleted } from '../../../helpers/analytics';
import { gaEvents, sendGACommonEvent } from '../../../helpers/gaTracker';
import './_Onboarding.module.scss';

const { Text } = Typography;
const OnboardingContentComponent = ({
  currentStep,
  steps,
  setIsOpen,
  setCurrentStep,
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'onboarding' });
  const { meta } = useTour();

  const content = steps[currentStep];

  const isLastStep = currentStep + 1 === steps.length;

  const renderTitle = (
    <Flex className="tw-w-full" justify="space-between">
      <Text strong className="tw-text-white">
        {content.title}
      </Text>
      <Button
        size="small"
        type="default"
        icon={<MdOutlineClose size={16} />}
        onClick={() => setIsOpen(false)}
        className="tw-text-white tw-bg-transparent tw-border-none"
      />
    </Flex>
  );

  const handleFinishTour = useCallback(() => {
    setIsOpen(false);
    sendGACommonEvent(gaEvents.FINISH_TOUR, {
      finishTitle: content.title,
    });
    trackOnboardingTourCompleted(meta);
  }, [content.title, meta, setIsOpen]);

  const handleNextStepTour = useCallback(() => {
    setCurrentStep(currentStep + 1);
  }, [currentStep, setCurrentStep]);

  return (
    <Flex vertical gap={8}>
      {renderTitle}
      <Text className="tw-text-white">{content.content}</Text>
      {isLastStep && (
        <Space orientation="vertical" className="tw-w-full">
          <Button
            type="primary"
            onClick={handleFinishTour}
            className="tw-w-full"
          >
            {t('finishTourBtn')}
          </Button>
        </Space>
      )}
      {!isLastStep && content?.hasNextStep && (
        <Space orientation="vertical" className="tw-w-full">
          <Button
            type="primary"
            onClick={handleNextStepTour}
            className="tw-w-full"
          >
            {t('nextStepTourBtn')}
          </Button>
        </Space>
      )}
    </Flex>
  );
};

OnboardingContentComponent.propTypes = {
  currentStep: PropTypes.number,
  setCurrentStep: PropTypes.func,
  setIsOpen: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.object),
};

OnboardingContentComponent.defaultProps = {
  currentStep: undefined,
  setCurrentStep: undefined,
  setIsOpen: undefined,
  steps: undefined,
};
export default OnboardingContentComponent;
